import React from "react";

export const ClientLicenseContext = React.createContext();